// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import Index from "./Index";
import router from "./router";
import VueMethod from "./common/js/method.js";
import VueResourceExt from "./common/js/resourceExt.vue.plugin.js";
import i18n from "@/lang";
Vue.config.productionTip = false;
Vue.use(VueMethod);
Vue.use(VueResourceExt);

import { Message } from "element-ui";

// 按需引入的组件会自动注册，无需手动Vue.use()
Vue.prototype.$message = Message;

import axios from "axios";
axios.defaults.withcredentials = true;
Vue.prototype.$axios = axios;

/**
 * 统一设置后台请求地址
 * 设置请求地址：config文件夹下的request.json
 */
//axios.defaults.baseURL = process.env._BASEURL
/** 统一设置后台请求地址 */
if (process.env.NODE_ENV === "development") {
  //本地开发地址
  axios.defaults.baseURL = "http://localhost:8084/dev";
  // axios.defaults.baseURL = "https://www.rongechain.com";
} else {
  //测试地址
  // axios.defaults.baseURL = 'https://recf.sit.sf-express.com:45391'

  // axios.defaults.baseURL = 'http://caihuilian.sit.sf-express.com:46001'
  //生产地址
  axios.defaults.baseURL = "";
  // axios.defaults.baseURL = 'https://www.caihuichain.com'
  // axios.defaults.baseURL = 'https://www.rongechain.com'
}
Vue.prototype.$axios = axios;

//POST传参序列化(添加请求拦截器)，该序列化方式也是根据实际情况加与不加
axios.interceptors.request.use(
  config => {
    //在发送请求之前如果为post序列化请求参数
    /*if(config.method === 'post') {
		config.data = qs.stringify(config.data);
	}*/
    config.headers["language"] = localStorage.getItem("lang");
    return config;
  },
  error => {
    sfopenVM.$toast.show({
      text: i18n.t("传参错误，请检查！"),
      type: "text",
      time: 1000,
      width: "auto"
    });
    return Promise.reject(error);
  }
);

function isWhiteList(url) {
  const whiteList = [
    "/official/outer/international/supportLanguage",
    "/official/outer/international/frontLanguageFiles"
  ];
  let flag = false;
  whiteList.forEach(item => {
    if (url.indexOf(item) !== -1) {
      flag = true;
    }
  });
  return flag;
}
//返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
    //对响应数据做判断，与后台协议统一接口返回格式
    if (
      res.data.succ != "ok" &&
      res.data.code != 200 &&
      !isWhiteList(res.config.url)
    ) {
      console.log("res.config.url", res.config.url);
      //这个判断可根据实际情况修改
      sfopenVM.$toast.show({
        text: res.data.msg ? res.data.msg : i18n.t("服务器请求失败，请重试！"),
        type: "text",
        time: 3000,
        width: "auto"
      });
      return Promise.reject(res);
    }
    return res;
  },
  error => {
    var msg = i18n.t("网络异常，请稍后再试！");
    sfopenVM.$toast.show({
      text: msg,
      type: "text",
      time: 1500,
      width: "auto"
    });
    return Promise.reject(error);
  }
);

import "./common/css/common.less";
router.beforeEach((to, from, next) => {
  if (document.getElementsByClassName("panel")[0]) {
    document.getElementsByClassName("panel")[0].scrollTop = 0;
  }
  window.scroll(0, 0);
  next();
});
/* eslint-disable no-new */
/*new Vue({
	router,
	el: '#web',
	render: h => h(Index)
})*/
var sfopenVM;
sfopenVM = new Vue({
  router,
  el: "#web",
  i18n,
  render: h => h(Index)
});



// WEBPACK FOOTER //
// ./src/main.js